import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TitleView from 'react/views/generic/TitleView';
import SingleCarouselView from 'react/views/carousel/SingleCarouselView';
import CarouselItem from 'react/views/carousel/CarouselItem';

const CarouselItemWidth = '134px';
const CardWidth = '225px';

class CardCarousel extends Component {
	renderBooks() {
		const seriesTitles = this.props.items.map((title) => {
			return (
				<CarouselItem key={title.uniqueId} itemWidth={CarouselItemWidth} itemHeight={this.props.itemHeight}>
					<TitleView title={title} 
						jacketClickEvent={this.props.jacketClickEvent} titleClickEvent={this.props.titleClickEvent} 
						otsFindItEvent={this.props.otsFindItEvent} otsClickEvent={this.props.otsClickEvent}
						otsEnabled={this.props.otsEnabled} small={this.props.small}/>
				</CarouselItem>
			);
		});
		return seriesTitles;
	}

	renderGeneric() {
		const entries = this.props.components.map((component, index) => {
			return (
				<CarouselItem key={index} itemWidth={CarouselItemWidth} itemHeight={this.props.itemHeight}>
					{component}
				</CarouselItem>
			);
		});
		return entries;
	}

	render() {
		let items = this.props.components ? this.renderGeneric() : this.renderBooks();

		return (
			<SingleCarouselView
				items={items}
				itemWidth={CarouselItemWidth}
				minMargin={0}
				marginTop={this.props.marginTop}
				marginBottom={this.props.marginBottom}
				width={CardWidth}
				reportUpdate={this.props.reportUpdate}
			/>
		);
	}
}

CardCarousel.propTypes = {
	jacketClickEvent: PropTypes.object,
	titleClickEvent: PropTypes.object,
	otsFindItEvent: PropTypes.object,
	otsClickEvent: PropTypes.object,
	items: PropTypes.arrayOf(PropTypes.object),
	reportUpdate: PropTypes.func,
	otsEnabled: PropTypes.bool,
	small: PropTypes.bool
}
CardCarousel.defaultProps = {
	small: false
}

export default CardCarousel;



// WEBPACK FOOTER //
// ./src/react/views/carousel/CardCarousel.jsx